import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";

import { ReactComponent as UserIcon } from "../../../assets/svg/user.svg";
import { ReactComponent as NotifyIcon } from "../../../assets/svg/bell.svg";
import topLogo from "../../../assets/images/top-logo.png";
import topLogoSp from "../../../assets/images/top-logo-sp.png";
import { ITeacher } from "../../../state";
import {
  selectTextbookPath,
  textbookPath,
  guidelinePath,
  activeLearningTextbookPath,
  activeLearningGuidelinePath,
} from "../../../teacherStore";
import { TEACHER_SESSION_KEY } from "../../../Definition";

import styles from "./HeaderBar.module.scss";

export interface IHeaderBar {
  isManager: boolean;
  teacher: ITeacher;
  school_name: string;
  isUnreadNews: boolean;
}

const HeaderBar: React.FC<IHeaderBar> = ({
  isManager,
  teacher,
  school_name,
  isUnreadNews,
}) => {
  const { pathname } = useLocation();
  const guidanceScreenPaths = [
    selectTextbookPath,
    textbookPath,
    guidelinePath,
    activeLearningTextbookPath,
    activeLearningGuidelinePath,
  ];
  const extra = sessionStorage.getItem(TEACHER_SESSION_KEY)
    ? `?session_id=${sessionStorage.getItem(TEACHER_SESSION_KEY)}`
    : "";
  const fullName = `${teacher.last_name} ${teacher.first_name}`;

  return (
    <div className={styles.headerBar}>
      <div className={styles.headerBar__sideLeft}>
        <a
          className={styles.brand}
          href={`${process.env.REACT_APP_ONE_MENU_URL}${extra}`}
        >
          <img className={styles.logo} src={topLogo} alt="brand logo" />
          <img className={styles.logoSp} src={topLogoSp} alt="brand logo" />
        </a>
        <a
          href={`${process.env.REACT_APP_ONE_MENU_URL}/contents/outline${extra}`}
        >
          はじめに
        </a>
        <a
          href={`${process.env.REACT_APP_ONE_MENU_URL}/contents/support_tools${extra}`}
        >
          教材補助ツール
        </a>
        <NavLink
          to={selectTextbookPath}
          className={
            guidanceScreenPaths.some(path => pathname.includes(path))
              ? styles.active
              : ""
          }
        >
          指導画面
        </NavLink>
        <a
          href={`${process.env.REACT_APP_ONE_MENU_URL}/class_retrospect${extra}`}
        >
          CORE振り返り
        </a>
        <a
          href={process.env.REACT_APP_HELP_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          ヘルプ
        </a>
        {isManager && (
          <a
            href={process.env.REACT_APP_MANAGER_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            管理者画面
          </a>
        )}
        {/* エントリー受付時期以外は非表示「ENAGEED SUMMITは毎年恒例イベント」 */}
        {/* <div className={styles.headerBar__sideLeft_summit}>
          <a
            className={styles.summit}
            href={`https://www.enageed.jp/summit/pre/2025`}
          >
            ENAGEED SUMMIT 2025
            <br />
            <span>- エントリー受付中 -</span>
          </a>
        </div> */}
      </div>
      <div className="d-flex align-items-center">
        <a
          className={clsx("position-relative d-flex", styles.notify)}
          href={`${process.env.REACT_APP_ONE_MENU_URL}/news_list`}
        >
          <NotifyIcon className={styles.notify_icon} />
          {isUnreadNews && <div className={styles.badge} />}
        </a>
        <div className={styles.nameSchool}>{school_name}</div>
        <div className={styles.headerBar__sideRight}>
          <a
            href={`${process.env.REACT_APP_ONE_MENU_URL}/profile_setting${extra}`}
            className={styles.userAccount}
          >
            <div>{fullName}</div>
            <UserIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
